import { render, staticRenderFns } from "./LessonMovie.vue?vue&type=template&id=22252035&scoped=true&"
import script from "./LessonMovie.vue?vue&type=script&lang=js&"
export * from "./LessonMovie.vue?vue&type=script&lang=js&"
import style0 from "./LessonMovie.vue?vue&type=style&index=0&id=22252035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22252035",
  null
  
)

export default component.exports